<div fxLayout="column" fxFlex>
	<div *ngIf="me" style="padding: 8px 16px; background-color: #4CAF50; color: white;">
		Currently connected as {{me.email}} (<a style="text-decoration: underline; cursor: pointer;" (click)="logout()">Logout</a>)
	</div>
	<div fxLayout="row" fxFlex>
		<mat-card fxLayout="column" fxFlex>
			<ng-container *ngIf="settings?.method; else noSettings">
				<mat-toolbar fxLayout="row" fxLayoutAlign="start center">
					<mat-icon>people</mat-icon>
					<span [matBadge]="nbUsers" matBadgeOverlap="false">
						Users
					</span>
					<span fxFlex></span>
					<button *ngIf="!displayEmailSettings && settings.email_verification && settings.email_addon" style="margin-right: 8px;" (click)="configureEmails()" mat-button>Configure emails</button>
					<button mat-mini-fab (click)="openSignupDialog()" matTooltip="New User" matTooltipPosition="left" style="width: 31px; height: 31px;">
						<mat-icon style="position: relative; top: -6px; left: -4px;">add</mat-icon>
					</button>
				</mat-toolbar>
				<ng-container *ngIf="!loading; else loadingUsers">
					<div *ngIf="users && users.length; else noUser" style="border-top: 1px solid #EEE; overflow-y: auto;" fxLayout="column" fxFlex>
						<div fxFlex fxLayout="column" [style.overflowY]="'auto'">
							<div fxLayout="row" fxLayoutAlign="start center" *ngFor="let user of users" style="border-bottom: 1px solid #EEE; cursor: pointer;min-height: 40px">
								<img [src]="user.gravatar" class="avatar" style="margin: 0 8px; width:32px; height:32px;border-radius: 100%" />
								<div style="color: #999; padding-top: 0" fxFlex>{{user.email}}</div>
								<div class="verified" *ngIf="settings?.email_verification">
									<span *ngIf="user.verified; else resendTemplate">verified</span>
									<ng-template #resendTemplate>
										<button mat-button (click)="resendVerification(user.id_user)">Resend verification</button>
									</ng-template>
								</div>
							</div>
						</div>
						<mat-paginator
							hidePageSize="true"
							showFirstLastButtons="true"
							[length]="nbUsers"
							[pageIndex]="defaultPageIndex"
							(page)="paginationEvent($event)">
						</mat-paginator>
					</div>
					<ng-template #noUser>
						<div fxFlex fxLayout="column" fxLayoutAlign="center center" class="no-users">
							<span>There is no users registered yet</span>
							<div>
								<button (click)="openSignupDialog()" mat-raised-button color="primary" [style.margin]="'15px'" [style.color]="'white'">
									Create a user
								</button>
							</div>
						</div>
					</ng-template>
				</ng-container>
			</ng-container>
		</mat-card>
		<ng-template #loadingUsers>
			<div fxLayout="column" fxFlex fxLayoutAlign="center center">
				<mat-spinner></mat-spinner>
			</div>
		</ng-template>
		<ng-template #noSettings>
			<div fxFlex fxLayout="column" fxLayoutAlign="center center" class="no-users">
				<span>It seems <strong>@materia/users</strong> addon is not configured yet</span>
				<div>
					<button (click)="openSetup.emit()" mat-raised-button color="primary" [style.margin]="'15px'" [style.color]="'white'">
						Settings
					</button>
				</div>
			</div>
		</ng-template>
		<div style="margin: 8px;" *ngIf="displayEmailSettings" fxLayout="column" fxFlex>
			<mat-toolbar fxLayout="row" fxLayoutAlign="start center">
				<button mat-icon-button (click)="hideEmailSettings()" matTooltip="Hide email settings" matTooltipPosition="right">
					<mat-icon>arrow_back</mat-icon>
				</button>
				<mat-icon>mail</mat-icon>
				<span>
					Emails
				</span>
				<span fxFlex></span>
			</mat-toolbar>
			<materia-user-management-email-settings [settings]="settings" [baseUrl]="baseUrl"
				(hide)="hideEmailSettings()" (save)="saveEmailSettings($event)" fxFlex style="overflow-y: auto;">
			</materia-user-management-email-settings>
		</div>
	</div>
</div>
<materia-signup-form #signupFormTemplate [profileFields]="profileFields" (signup)="signup($event)" (cancel)="closeSignupDialog()"></materia-signup-form>